<template>
    <div id="guarantee-control" class="px-4">
        <div class="vx-row">
            <div class="vx-col w-full">
                <h3 class="mb-1">Información del obligado solidario.</h3>
                <p>Contar con un obligado solidario te permite obtener mejores condiciones para tu crédito y puede responder por el pago del mismo.</p>
                <vs-divider></vs-divider>
            </div>
            <div v-if="!isAddOrEdit" class="vx-col w-full">
                <h4 class="mb-base mt-4">Obligados Solidarios</h4>
                <div v-for="guarantee in guaranteesList" class="vx-col w-full mb-base">
                    <p class="bold flex"><span class="mt-2">{{ getGuaranteeName(guarantee.guarantee_profile) }} &nbsp;&nbsp; <span v-if="isFromApplicantView" @click.stop="setUpGuaranteeForm(1, guarantee)" class="font-regular clickable-img text-sm"><u class="mt-1">Editar</u><feather-icon class="mr-2 h-5 w-5 ml-2 mt-1" icon="EditIcon"></feather-icon></span></span></p>
                    <p class="mb-3">{{ guarantee.guarantee_profile.email }} | {{ getGuaranteePhone(guarantee) }}</p>
                    
                    <vs-chip class="chip-black mr-2" :color="getGuaranteeStatus(guarantee.guarantee_profile).color">{{ getGuaranteeStatus(guarantee.guarantee_profile).status }} &nbsp;&nbsp;</vs-chip>
                    <p @click.stop="requestNotificationToGuarantee(guarantee)" class="text-sm flex mt-1 clickable-img">
                        <u class="mt-1">Enviar recordatorio</u>
                        <feather-icon class="mr-2 h-5 w-5 ml-2 mt-1" icon="SendIcon"></feather-icon>
                    </p>
                </div>
                <div class="vx-col w-full">
                    <!-- BOTONES -->
                    <div class="flex justify-end">
                        <vs-button color="primary" class="mt-2"
                            @click.stop="setUpGuaranteeForm(0)">Agregar obligado solidario</vs-button>
                    </div>
                </div>
            </div>
            <div v-else>
                <GuaranteeForm 
                v-if="isAddOrEdit"
                :guarantee="currentGuarantee" 
                :project="project"
                :hasFirstGuarantee="hasAtLeastOneFullGuarantee"
                @canceled="onCancel" 
                @saved="onSaved" />
            </div>
        </div>
    </div>
</template>

<script>

/**
 * La regla es:
 * Sí no tiene un Os con email, debe mostrar de una el form
 * Sí tiene por lo menos un OS, muestra el listado
 * sí guaranteesList.length > 0 && email == null
 */

const currentGuaranteeObj = {
    guarantee_profile: {
        id: null, 
        email: null,
        relation_with_applicant: null,
        personal_profile_id: null,
        rejected_date: null,
        approved_date: null,
        personal: {
            id: null,
            first_name: null,
            second_name: null,
            last_name_1: null,
            last_name_2: null,
            birth_date: null,
            phone: {
                country_calling_code: null,
                phone: null
            }
        }
    }
};

import GuaranteeForm from './GuaranteeForm.vue';
import formatHelper from "@mixins/formatHelper";
    export default {
        name: "GuaranteeControl",
        mixins: [formatHelper],
        components: {
            GuaranteeForm
        },
        data: () => ({
            currentGuarantee: currentGuaranteeObj,
            isAddOrEdit: false,
            guaranteeSelected: null
        }),
        props: {
            project: Object,
            isFromApplicantView: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            if(!this.hasAtLeastOneFullGuarantee) {
                if(this.guaranteesList.length == 0) {
                    this.currentGuarantee = currentGuaranteeObj;
                } else {
                    this.currentGuarantee = this.guaranteesList[0];
                }
                this.isAddOrEdit = true;
            }
        },
        computed: {
            guaranteesList() {
                return this.project.finance.guarantees_list || [];
            },
            hasAtLeastOneFullGuarantee() {
                return this.guaranteesList.length > 0 && (this.guaranteesList[0].guarantee_profile.email != null && this.guaranteesList[0].guarantee_profile.email != "");
            }
        },
        methods: {
            getGuaranteeName(guaranteeProfile) {
                if(guaranteeProfile.personal_profile_id != null) {
                    return `${guaranteeProfile.personal.first_name||""} ${guaranteeProfile.personal.second_name||""} ${guaranteeProfile.personal.last_name_1||""} ${guaranteeProfile.personal.last_name_2||""}`
                } else {
                    return `${guaranteeProfile.business.name}`;
                }
            },
            getGuaranteeStatus(guaranteeProfile) {
                    const guaranteeData = {
                        color: "#FFF1E3",
                        status: "Pendiente",
                        canEdit: true,
                        canSendMail: true
                    }

                    if(guaranteeProfile.rejected_date != null) {
                        guaranteeData.color = "#FEE2E2";
                        guaranteeData.status = "Rechazado";
                        guaranteeData.canEdit = true;
                        guaranteeData.canSendMail = false;
                    } else if(guaranteeProfile.approved_date != null) {
                        guaranteeData.color = "#D4F8D1";
                        guaranteeData.status = "Aprobado";
                        guaranteeData.canEdit = guaranteeProfile.guarantee_profile_step == null;
                        guaranteeData.canSendMail = true;
                    }

                    return guaranteeData
            },
            setUpGuaranteeForm( flow, guarantee = null ) {
                if(flow === 0) {
                    this.currentGuarantee = currentGuaranteeObj;
                    this.isAddOrEdit = true;
                } else {
                    this.currentGuarantee = guarantee;
                    this.isAddOrEdit = true;
                }
            },
            onCancel() {
                this.isAddOrEdit = false;
                this.currentGuarantee = currentGuaranteeObj;
            },
            onSaved() {
                this.isAddOrEdit = false;
                this.currentGuarantee = currentGuaranteeObj;
                this.$emit("saved");
            },
            requestNotificationToGuarantee(guarantee) {
                this.guaranteeSelected = guarantee;
                this.$vs.dialog({
                    type: 'confirm',
                    color: '#3B3A3E',
                    title: 'Notificación',
                    text: `Se enviará un recordatorio al obligado solidario de tu cliente para que concluya su proceso.`,
                    acceptText: "Enviar",
                    cancelText: 'Cancelar',
                    accept: this.doSendGuaranteeReminder
                });
            },
            async doSendGuaranteeReminder()
            {
                console.log("Enviando recordatorio a: ", this.guaranteeSelected);
                try {
                    this.showLoading(true);
                    await axios.post(`/api/guarantee/post/${this.guaranteeSelected.guarantee_profile_id}/send-reminder/1`);
                    this.saveSuccessNotif();
                    
                    this.showLoading(false);
                } catch (error) {
                    this.showLoading(false);
                    this.failedOperationNotif();
                } finally {
                    this.showLoading(false);
                }
            },
            getGuaranteePhone(guarantee) {
                // console.log("Obteniendo teléfono de garantía: ", guarantee);
                if(guarantee.guarantee_profile.personal_profile_id != null) {
                    return `${guarantee.guarantee_profile.personal?.phone.country_calling_code||""} ${this.phoneFormat(guarantee.guarantee_profile.personal?.phone.phone)}`||"--";
                } else {
                    return `${guarantee.guarantee_profile.business?.phone.country_calling_code||""} ${this.phoneFormat(guarantee.guarantee_profile.business?.phone.phone)}`||"--";
                }
            }
        }
    }
</script>